<template>
  <v-container fluid class="d-flex flex-column justify-center align-center h-full">
    <h1 class="mb-8 text-center">
      <span class="d-block display-4">SORRY!</span>
      <span class="d-block display-1 font-weight-thin">THIS PAGE DOESN'T EXIST!</span>
    </h1>
    <p class="subtitle-2 text--secondary">ERROR 404</p>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo () {
    return {
      titleTemplate: 'Not Found - ネッツトヨタ福岡'
    }
  }
}
</script>
